import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaTruck, FaRoute, FaMapMarkerAlt, FaUsers, FaVolumeUp, FaEye, 
  FaClock, FaChartLine, FaShieldAlt, FaDownload, FaCheckCircle, 
  FaStar, FaArrowRight, FaCog, FaWarehouse, FaRoad, FaBell 
} from 'react-icons/fa';
import './VysypPage.css';

const VysypPage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const features = [
    {
      icon: FaTruck,
      title: 'Registrácia vozidiel',
      description: 'Automatická registrácia kamiónov pri vstupe do areálu s identifikáciou vodiča a nákladu'
    },
    {
      icon: FaRoute,
      title: 'Inteligentné smerovanie',
      description: 'Automatické určenie optimálnej trasy k rampe na základe poradia a typu nákladu'
    },
    {
      icon: FaMapMarkerAlt,
      title: 'Navigácia v reálnom čase',
      description: 'GPS navigácia s presným vedením k správnej rampe a parkovaciemu miestu'
    },
    {
      icon: FaUsers,
      title: 'Manažment frontu',
      description: 'Prehľadný systém spravovania poradia vozidiel a optimalizácia času čakania'
    },
    {
      icon: FaVolumeUp,
      title: 'Audiovizuálna signalizácia',
      description: 'Hlasové pokyny a vizuálne signály na jednoduchú orientáciu v areáli'
    },
    {
      icon: FaEye,
      title: 'Monitorovanie v reálnom čase',
      description: 'Kontinuálne sledovanie pozície vozidiel a stavu rampy prostredníctvom kamier'
    }
  ];

  const benefits = [
    {
      icon: FaClock,
      title: 'Čas čakania',
      value: '60%',
      description: 'Zníženie času čakania vozidiel v areáli'
    },
    {
      icon: FaChartLine,
      title: 'Efektivita rampy',
      value: '40%',
      description: 'Zvýšenie produktivity nakladania/vykladania'
    },
    {
      icon: FaRoute,
      title: 'Optimalizácia trás',
      value: '30%',
      description: 'Skrátenie času potrebného na navigáciu'
    },
    {
      icon: FaUsers,
      title: 'Spokojnosť vodičov',
      value: '95%',
      description: 'Vyššia spokojnosť vďaka jasným inštrukciám'
    }
  ];

  const packages = [
    {
      name: 'BASIC VYSYP',
      price: '299€',
      description: 'Pre menšie skladové areály',
      features: [
        'Registrácia vozidiel',
        'Základné smerovanie',
        'Manažment frontu',
        'Web dashboard',
        'Do 5 rampy',
        'Email podpora'
      ]
    },
    {
      name: 'STANDARD VYSYP',
      price: '599€',
      description: 'Pre stredné logistické centrá',
      features: [
        'Všetky funkcie BASIC',
        'GPS navigácia',
        'Audiovizuálna signalizácia',
        'Mobilná aplikácia',
        'Do 15 rampy',
        'SignalR komunikácia',
        'Prioritná podpora'
      ],
      popular: true
    },
    {
      name: 'PREMIUM VYSYP',
      price: '1299€',
      description: 'Pre veľké distribučné centrá',
      features: [
        'Všetky funkcie STANDARD',
        'Pokročilá analytika',
        'Kamerový systém',
        'API integrácie',
        'Neobmedzený počet rampy',
        'Podpora 24/7',
        'Onsite konzultácie'
      ]
    }
  ];

  const industries = [
    {
      icon: FaWarehouse,
      title: 'Distribučné centrá',
      description: 'Veľké logistické haly s množstvom rampy'
    },
    {
      icon: FaTruck,
      title: 'Prepravné spoločnosti',
      description: 'Firmy s vlastnými skladovými areálmi'
    },
    {
      icon: FaCog,
      title: 'Výrobné podniky',
      description: 'Továrne s príjmom/výdajom materiálu'
    },
    {
      icon: FaRoad,
      title: 'Logistické parky',
      description: 'Komplexné areály s viacerými spoločnosťami'
    }
  ];

  const technologies = [
    {
      name: 'React',
      description: 'Frontend používateľského rozhrania',
      color: '#61dafb'
    },
    {
      name: 'C#',
      description: 'Backend aplikačná logika',
      color: '#239120'
    },
    {
      name: 'MSSQL',
      description: 'Databázový systém',
      color: '#cc2927'
    },
    {
      name: 'SignalR',
      description: 'Komunikácia v reálnom čase',
      color: '#512bd4'
    },
    {
      name: 'MUI',
      description: 'Material-UI komponenty',
      color: '#0081cb'
    }
  ];

  const testimonials = [
    {
      name: 'Ing. Marián Kováč',
      company: 'LOGISTIKA PLUS s.r.o.',
      text: 'NAVIS nám revolucionizoval správu areálu. Vodiči sa už nestratia a čakacie časy sa dramaticky skrátili.',
      rating: 5
    },
    {
      name: 'Peter Hrubý',
      company: 'CARGO CENTER',
      text: 'Audiovizuálna signalizácia je skvelá. Vodiči zo zahraničia nemajú problém nájsť správnu rampu.',
      rating: 5
    }
  ];

  return (
    <div className="vysyp-page">
      {/* Hero Section */}
      <section className="vysyp-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>NAVIS</h1>
              <h2>Inteligentný systém pre skladové areály</h2>
              <p>
                Inteligentný systém na riadenie a navigáciu vodičov kamiónov v rámci skladových areálov 
                – od registrácie po obslúženie na rampe. Automatické smerovanie podľa poradia, 
                prehľadný manažment toku vozidiel a možnosť audiovizuálnej signalizácie.
              </p>
              <div className="hero-actions">
                <Link to="/kontakt" className="btn btn-primary">
                 <FaArrowRight /> Žiadosť o ponuku
                </Link>
              </div>
            </div>
            <div className="hero-image">
              <img src="/vysyp.png" alt="Vysyp System" className="hero-product-image" />
            </div>
          </div>
        </div>
      </section>

      {/* Technologies Section */}
      <section className="technologies-section">
        <div className="container">
          <h2>Technológie, ktoré používame</h2>
          <div className="technologies-grid">
            {technologies.map((tech, index) => (
              <div key={index} className="technology-card">
                <div className="tech-name" style={{ color: tech.color }}>
                  {tech.name}
                </div>
                <p>{tech.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2>Pokročilé funkcie systému</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">
                  <feature.icon />
                </div>
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2>Výsledky, ktoré môžete očakávať</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">
                  <benefit.icon />
                </div>
                <div className="benefit-value">{benefit.value}</div>
                <h4>{benefit.title}</h4>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="industries-section">
        <div className="container">
          <h2>Vhodné pre všetky typy areálov</h2>
          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-card">
                <div className="industry-icon">
                  <industry.icon />
                </div>
                <h4>{industry.title}</h4>
                <p>{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Customer Section */}
      <section className="customers-section">
        <div className="container">
          <h2>Náš klient</h2>
          <div className="customers-grid">
            <a 
              href="https://www.crocodille.com/cs/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="customer-card"
            >
              <img src="/crocodille_logo.png" alt="Crocodille ČR" />
              <h3>Crocodille ČR, spol. s r. o.</h3>
              <p>Firma Crocodille ČR sa zaoberá výrobou a predajom v segmente FMCG (obložené bagety a sendviče). Je dlhodobo jednotkou trhu v Českej republike.</p>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VysypPage;